import { Button, Checkbox, Stack, Typography } from "@mui/material";
import React from "react";
import { MdOutlineFavorite, MdOutlineFavoriteBorder } from "react-icons/md";
import { useUser } from "../hooks/useUser";
import Insignia5RC from "./Insignia5RC";

const parseFavorites = (favorites) => {
  if (!favorites) return [];

  if (Array.isArray(favorites)) return favorites;

  if (typeof favorites === "string") {
    try {
      const parsed = JSON.parse(favorites);

      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.favorites)) return parsed.favorites;

      return [];
    } catch (error) {
      console.error("Error parseando favorites:", error);
      return [];
    }
  }

  if (typeof favorites === "object") {
    if (Array.isArray(favorites.favorites)) return favorites.favorites;
    return [];
  }

  return [];
};

// generos_musicales puede venir como array, string JSON o string plano
const parseGeneros = (generos) => {
  if (Array.isArray(generos)) return generos;
  if (typeof generos === "string") {
    try {
      const parsed = JSON.parse(generos);
      return Array.isArray(parsed) ? parsed : [String(parsed)];
    } catch {
      return generos ? [generos] : [];
    }
  }
  return [];
};

// En la card se muestran máximo `max` géneros; el resto se resume como "+N más"
// (el detalle completo vive en el modal "Ver más")
export const formatGeneros = (generos, max = 5) => {
  const lista = parseGeneros(generos);
  if (lista.length === 0) return "";
  const visibles = lista.slice(0, max).join(", ");
  const restantes = lista.length - max;
  return restantes > 0 ? `${visibles} +${restantes} más` : `${visibles}.`;
};

const CardsProductores = ({
  dataItem = {},
  loading = false,
  handleOpen,
  updateFavorite,
  handleSelectProducers,
  producers = [],
}) => {
  const { user } = useUser();

  const favoriteIds = parseFavorites(user?.profile?.favorites);
  const isFavorite = favoriteIds.includes(dataItem.id);

  return (
    <Stack
      sx={{
        width: "200px",
        p: "15px",
        gap: "10px",
        borderRadius: "10px",
        justifyContent: "space-between",
        ":hover": {
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 15px",
        },
      }}
    >
      <Stack gap="10px">
        <Stack>
          <img
            src={dataItem?.profile?.profileimg || "/assets/AVATAR.jpg"}
            width="100%"
            style={{
              borderRadius: "10px",
              boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 15px",
            }}
          />
        </Stack>

        <Stack>
          <Stack direction="row">
            <Typography
              noWrap
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "170px",
              }}
            >
              {dataItem?.profile?.nombre_media}
            </Typography>

            <img
              src={`https://flagcdn.com/${dataItem?.profile?.pais}.svg`}
              alt="País"
              width="30"
              height="20"
            />
          </Stack>

          <Typography variant="body1" color="grayText" fontWeight={400}>
            {dataItem?.profile?.tipo}
          </Typography>

          {dataItem?.acepta5RC && (
            <Insignia5RC
              tipo={dataItem?.profile?.tipo}
              sx={{ alignSelf: "flex-start", mt: 0.5 }}
            />
          )}

          <Stack>
            <Typography component="p" fontWeight={400}>
              {formatGeneros(dataItem?.profile?.generos_musicales)}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Checkbox
              checked={producers.some((p) => p.productorId === dataItem.id)}
              onChange={({ target }) => handleSelectProducers(target, dataItem)}
            />

            <Typography
              variant="body1"
              sx={{
                fontWeight: "400",
                cursor: "pointer",
                textDecoration: "underline",
                ":hover": { color: "#F27224" },
              }}
              onClick={() =>
                handleOpen(dataItem.id, {
                  ...dataItem.profile,
                  acepta5RC: dataItem.acepta5RC,
                })
              }
            >
              Ver mas
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        display={producers.length > 0 ? "none" : "inherit"}
      >
        <Button sx={{ px: 4 }} onClick={() => handleOpen(dataItem.id)}>
          Enviar
        </Button>

        <Button
          sx={{ px: "6px", fontSize: "24px", flexGrow: "1" }}
          onClick={() => updateFavorite(dataItem.id)}
          variant="text"
        >
          {isFavorite ? <MdOutlineFavorite /> : <MdOutlineFavoriteBorder />}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CardsProductores;